import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Landing from '../views/Landing.vue'
import Privacy from '../views/PrivacyEl.vue'
import Terms from '../views/TermsEl.vue'
import Article from '../views/ArticleHowItWorks.vue'
// import Support from '../views/SupportHub.vue'
// import Articles from '../views/ArticlesHub.vue'
import Pricing from '../views/Pricing.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
  }, 
  {
    path: '/flex-time-management',
    name: 'Flex Time',
    component: Landing,
  },
  {
    path: '/remote-work-management',
    name: 'Remote Work',
    component: Landing
  },
  {
    path: '/timezones-management-for-teams',
    name: 'Timezones Management',
    component: Landing
  },
  // {
  //   path: '/support',
  //   name: 'Support',
  //   component: Support,
  // },
  // {
  //   path: '/articles',
  //   name: 'Articles',
  //   component: Articles
  // },
  // {
  //   path: 'Articles/:title',
  //   name: 'Article',
  //   component: Article
  // },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Privacy.vue')
  },
  {
    path: '/TOS',
    name: 'Terms of Service',
    component: Terms,
  },
  {
    path: '/how-it-works',
    name: 'How it works',
    component: Article
  }
]

// for SEO we should use CreateWebHistory

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // TODO: some navigation clicks dont scroll correctly
    // if (to) return null

    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router
